import CleartripLogo from './assets/cleartrip.png'
import DiceLogo from './assets/dice.png'
import YesLogo from './assets/yesbank.png'
import ZaggleLogo from './assets/Zaggle.jpeg'

const useLogoHooks = () => {
	const saas = window.location.origin.includes('cockpit.dice.tech') || window.location.origin.includes('localhost');
	 if(window.origin.includes("cleartrip")){
		 return CleartripLogo;
	 }
	 if(window.origin.includes("yesleap") || window.origin.includes('yespayleaf')){
		 return YesLogo;
	 }
	 if(saas){
		 return ZaggleLogo;
	 }
	return DiceLogo;
}


export default useLogoHooks;
